import React from "react";

// ============================================================
// Badge — Phase 1 status-label primitive.
// ============================================================
// Small inline-flex pill used to label member statuses,
// appointment types, attendance results, tree levels, and
// record states (ACTIVE, VISITOR, PRESENT, PENDING, etc.).
//
// Colour + background flip automatically between light and
// dark mode via the token variables — the component does not
// need any `.dark`-scoped overrides.
// ============================================================

const VARIANT_STYLE = {
  green:  { color: "var(--kc-green)",  background: "var(--kc-green-bg)" },
  blue:   { color: "var(--kc-accent)", background: "var(--kc-accent-bg)" },
  amber:  { color: "var(--kc-amber)",  background: "var(--kc-amber-bg)" },
  red:    { color: "var(--kc-red)",    background: "var(--kc-red-bg)" },
  grey:   { color: "var(--kc-grey)",   background: "var(--kc-grey-bg)" },
  purple: { color: "var(--kc-purple)", background: "var(--kc-purple-bg)" },
};

export function Badge({ variant = "grey", className = "", children, style = {}, ...rest }) {
  const palette = VARIANT_STYLE[variant] || VARIANT_STYLE.grey;
  const combined = ["text-badge", className].filter(Boolean).join(" ");
  return (
    <span
      className={combined}
      style={{
        display: "inline-flex",
        alignItems: "center",
        borderRadius: 20,
        padding: "3px 8px",
        ...palette,
        ...style,
      }}
      {...rest}
    >
      {children}
    </span>
  );
}

export default Badge;
